import { useControlledHotkeys } from '@tribeplatform/react-components/common/hooks'
import { useI18n } from '@tribeplatform/react-components/i18n'
import { ButtonGroup, IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { useCustomizer } from '../hooks/index.js'
import { CustomizerActionType } from '../types.js'

export const PreviewRedoUndo = () => {
  const { $t } = useI18n()
  const {
    state: { updates, currentUpdateIdx },
    dispatch,
  } = useCustomizer()
  const undoAvailable = currentUpdateIdx > -1
  const redoAvailable = currentUpdateIdx < updates.length - 1

  useControlledHotkeys('cmd+z,ctrl+z', () => {
    dispatch({ type: CustomizerActionType.UNDO_UPDATE })
  })
  useControlledHotkeys('cmd+shift+z,ctrl+shift+z', () => {
    dispatch({ type: CustomizerActionType.REDO_UPDATE })
  })

  return (
    <ButtonGroup size="md">
      <IconButton
        disabled={!undoAvailable}
        onClick={() => dispatch({ type: CustomizerActionType.UNDO_UPDATE })}
        icon={<SvgIcon className="rtl:-scale-x-100" name="undo" />}
        accessibilityLabel={$t({
          defaultMessage: 'Undo',
          id: 'Generics.Undo',
        })}
        tooltip
      />
      <IconButton
        disabled={!redoAvailable}
        onClick={() => dispatch({ type: CustomizerActionType.REDO_UPDATE })}
        icon={<SvgIcon className="rtl:-scale-x-100" name="redo" />}
        accessibilityLabel={$t({
          defaultMessage: 'Redo',
          id: 'Generics.Redo',
        })}
        tooltip
      />
    </ButtonGroup>
  )
}
